import React from 'react';
import { MdSearchOff } from 'react-icons/md';
import './NoData.css';

const NoData = ({ title = 'No Data Found', message = 'There is no data available at the moment.' }) => {
    return (
        <div className="no-data-container">
            <div className="no-data-icon">
                <MdSearchOff />
            </div>
            <h3 className="no-data-title">{title}</h3>
            <p className="no-data-message">{message}</p>
        </div>
    );
};

export default NoData;
